import React, { useState } from "react";
import "./CustomAccordion.scss";
import { CheckCircleOutlined, CloseCircleOutlined, DownOutlined, SyncOutlined, UpOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Tag } from "antd";
import useAuth from "../../core/hooks/useAuth";


const CustomAccordion = ({
  data,
  handleAcceptRequest,
  handleRejectRequest,
}) => {
  const [isCardVisible, setIsCardVisible] = useState(false);
  const toggleCard = () => {
    setIsCardVisible(!isCardVisible);
  };

  const { authenticatedUser } = useAuth();

  const { headerLabels, actionButtons, status, additionalInformation } = data;
  const description = data.content[1];

  const handleCardContentClick = (e) => {
    e.stopPropagation();
  };

  const renderStatusTag = () => {
    switch (status) {
      case "accepted":
        return (
          <Tag icon={<CheckCircleOutlined />} color="success">
            Validated
          </Tag>
        );
      case "pending":
        return <Tag icon={<SyncOutlined />} color="processing">Pending</Tag>;
      case "rejected":
        return (
          <Tag icon={<CloseCircleOutlined />} color="error">
            Rejected
          </Tag>
        );
      default:
        return null;
    }
  };

   const additionalInformationData = [
  
      {
        key: "created",
        content: additionalInformation?.created,
      },
      {
        key: "lastModified",
        content: additionalInformation?.lastModified,
      },
      {
        key: "approvedBy",
        content: additionalInformation?.approvedBy,
      },
    ];
  

  return (
    <>
      <div className={`card ${isCardVisible ? "open" : ""}`}>
        <div className="card-header-training">
          {headerLabels.map((label, index) => (
            <label
              key={index}
              className={
                (status === "pending" ||
                  status === "rejected" ||
                  status === "accepted") &&
                (label === "pending" ||
                  label === "rejected" ||
                  label === "accepted")
                  ? "label-pending"
                  : ""
              }
            >
              {label === "username" && authenticatedUser
                ? authenticatedUser.firstName
                : label}
            </label>
          ))}
          {renderStatusTag()}
          <div className="buttons">
            {actionButtons.includes("Accept") && (
              <Popconfirm
                title={`Are you sure you want to Accept this Request?`}
                onConfirm={() => {
                  if (status !== "accepted") {
                    handleAcceptRequest(data.id);
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="primary"
                  className={` ${
                    status === "accepted" ? "disabled" : ""
                  }`}
                  id="acceptBtn"
                >
                  Accept
                </Button>
              </Popconfirm>
            )}
            {actionButtons.includes("Decline") && (
              <Popconfirm
                title={`Are you sure you want to Reject this Request?`}
                onConfirm={() => {
                  if (status !== "rejected") {
                    handleRejectRequest(data.id);
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  className={
                    status === "rejected" ? "disabled" : ""
                  }
                  id="declineBtn"
                >
                  Decline
                </Button>
              </Popconfirm>
            )}
            <div className="icon-wrapper" onClick={toggleCard}>
              {isCardVisible ? <UpOutlined /> : <DownOutlined />}
            </div>
          </div>
        </div>

        <div className="card-content" onClick={handleCardContentClick}>
          {isCardVisible && (
            <div className="content-container">
              {
                description !== null && (
                  <div className="content-header">
                    <h4> Description</h4>
                    <p>{description}</p>
                  </div>
                )}
              <div className="content-informations">
                {additionalInformationData.map((info, index) => (
                  <div className="information-container" key={index}>
                    <label className="information-label">{info.key}:</label>{" "}
                    {info.content}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomAccordion;
